import { Select } from '@percent/lemonade';
import { useCountries } from '@percent/grants-nomination-form/hooks';
import { CountrySelectProps } from './CountrySelect.types';
import { SelectOption } from '@percent/grants-nomination-form/api/nominationForm/nominationForm.types';

export const CountrySelect = ({ value, ...props }: CountrySelectProps) => {
  const countries = useCountries();
  const countryCodes: SelectOption[] = countries.map((country) => ({ value: country.code, label: country.name }));

  return (
    <Select
      options={countryCodes}
      defaultValue={countryCodes.find((country) => country.value === value)}
      searchable
      {...props}
    />
  );
};
